<template>
  <NText variant="caption1" weight="bold" class="pr-3">
    {{ t('common.recentRequests') }}
  </NText>

  <div
    class="bg-neutral-secondary p-4 rounded-md mt-1 w-[456px] max-h-[27rem] flex flex-col"
  >
    <NTable
      v-if="deposits.length"
      ref="loadMoreRef"
      :data="deposits"
      :striped="false"
      :column-splitter="false"
      cell-padding="small"
      fixed-header
      class="mb-2 basis-[fit-content]"
    >
      <NTableColumn v-slot="{ row }">
        <NegarInfoWithBorderIcon
          size="20"
          class="cursor-pointer"
          @click="openDepositHistoryInfoDialog(row)"
        />
      </NTableColumn>

      <NTableColumn
        v-slot="{ row }"
        :label="`${t('common.amount')} (${t('misc.rial')})`"
        prop="amount"
        sortable
        align="text-right"
      >
        <Number #="{ number }" :value="row.amount" round>
          <NText :key="row.amount" variant="caption2">
            {{ number }}
          </NText>
        </Number>
      </NTableColumn>

      <NTableColumn
        v-slot="{ row }"
        :label="t('deposit.entry_time')"
        prop="entryDate"
        sortable
        align="text-right"
      >
        <NText :key="row.entryDate" variant="caption2">
          {{ creationTime(row.entryDate) }}
        </NText>
      </NTableColumn>

      <NTableColumn
        v-slot="{ row }"
        :label="t('deposit.status')"
        prop="isVerified"
        sortable
        align="text-right"
      >
        <NText
          v-if="row.isVerified"
          :key="row.isVerified"
          class="text-brand-primary"
          variant="caption2"
        >
          {{ t('deposit.status_done') }}
        </NText>

        <NText
          v-else
          :key="row.isVerified"
          variant="caption2"
          class="text-critical-primary"
        >
          {{ t('deposit.status_rejected') }}
        </NText>
      </NTableColumn>
    </NTable>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useInfiniteGetDepositsQuery } from '@core/cash';
import { NegarInfoWithBorderIcon } from '@negar/icons';

import Number from '@/components/Number.vue';

import { useCashDialogs } from '@/modules/cash';

const { deposits, loadMoreRef } = useInfiniteGetDepositsQuery();

const { t, d } = useI18n();

const { openDepositHistoryInfoDialog } = useCashDialogs();
const creationTime = (date) =>
  `${d(date, 'shortDate')} ,
    ${d(date, 'shortTime')}`;
</script>
